import { render, staticRenderFns } from "./BackendList.vue?vue&type=template&id=50b9adda&scoped=true&"
import script from "./BackendList.vue?vue&type=script&lang=js&"
export * from "./BackendList.vue?vue&type=script&lang=js&"
import style0 from "./BackendList.vue?vue&type=style&index=0&id=50b9adda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b9adda",
  null
  
)

export default component.exports